import { browserTracingIntegration, extraErrorDataIntegration, init } from '@sentry/vue'
import type { App } from 'vue'

import router from '@/router'

export function createSentry(app: App<Element>) {
    init({
        app,
        dsn: 'https://bbd727a68665bc823b624e9d316f9a7e@sentry.it-team.cloud/174',
        tracePropagationTargets: ['localhost', 'localhost:5173'],
        integrations: [
            browserTracingIntegration({
                router
            }),
            extraErrorDataIntegration()
        ]
    })
}
